import { useMemo } from "react";

import { useApiQuery } from "@/api";
import useCurrentEnvironment from "@/hooks/use-environment";
import { UnifiedTrackerRow, UnifiedWtmReportResponse } from "../types";

function parseUnifiedWtmReport(
  data: UnifiedWtmReportResponse,
): UnifiedWtmReportResponse {
  const rows: UnifiedTrackerRow[] = (data.rows ?? []).map((row) => ({
    ...row,
    domains: row.domains ?? [row.domain],
    pageResolutionCount: row.pageResolutionCount ?? 0,
    firstDetectedAt: row.firstDetectedAt ? new Date(row.firstDetectedAt) : null,
    lastDetectedAt: row.lastDetectedAt ? new Date(row.lastDetectedAt) : null,
  }));
  return { rows };
}

export default function useFetchUnifiedWtmReport() {
  const environment = useCurrentEnvironment();

  const query = useApiQuery(["get_unified_wtm_report", {}], {
    enabled: !!environment?.ID,
    retry: (failureCount, error) => {
      if (failureCount >= 2) {
        return false;
      }
      return (error as { retryable?: boolean }).retryable !== false;
    },
  });

  const data = useMemo(
    () => (query.data ? parseUnifiedWtmReport(query.data) : query.data),
    [query.data],
  );

  return { ...query, data };
}
